import React from "react";
import SARIcon from "./SARIcon";

function formatAmount(value, decimals = 2) {
  if (value == null || value === "") return null;
  if (typeof value === "number") {
    if (decimals === null) return String(value);
    if (typeof decimals === "number") return value.toFixed(decimals);
    return value.toFixed(2);
  }
  return String(value);
}

const PriceDisplay = ({
  value,
  className = "",
  style = {},
  iconSize = 14,
  color = "",
  decimals = 2,
}) => {
  const priceValue = formatAmount(value, decimals);
  if (priceValue == null) return "-";

  return (
    <span
      className={["price-display", className].filter(Boolean).join(" ")}
      style={style}
      dir="ltr"
    >
      <SARIcon
        size={iconSize}
        className="shrink-0 price-display__symbol"
        color={color}
      />
      <span className="price-display__amount">{priceValue}</span>
      <span className="visually-hidden">Saudi Riyals</span>
    </span>
  );
};

export default PriceDisplay;
